import Container from "components/ui/Container"
import Heading from "components/ui/Heading"

const certifications = [
  {
    name: "HIPAA",
    description: "Healthcare data compliance",
    logo: "/images/pages/trust-and-security/compliance/hipaa.png",
  },
  {
    name: "SOC 2 Type 2",
    description: "Security & availability certified",
    logo: "/images/pages/trust-and-security/compliance/soc2.jpg",
  },
  {
    name: "PCI-DSS Level 2",
    description: "Payment card data protection",
    logo: "/images/pages/trust-and-security/compliance/pci-dss.svg",
  },
]

function ComplianceBadgesSection() {
  return (
    <Container section>
      <Heading
        label="Enterprise-Grade Compliance"
        title="One Platform, Multiple Regulatory Frameworks"
        subtitle="Preset satisfies HIPAA, SOC 2, and PCI-DSS simultaneously — so organizations operating across healthcare, finance, and international boundaries don't need separate tools for separate compliance regimes."
        decoration="border"
      />
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {certifications.map((cert) => (
          <div
            key={cert.name}
            className="flex flex-col items-center rounded-2x border border-drift-grey bg-white p-8 text-center shadow-sm transition-shadow hover:shadow-md"
          >
            <img
              src={cert.logo}
              alt={`${cert.name} certification`}
              className="mb-4 h-16 w-auto object-contain"
            />
            <h3 className="text-xl font-bold text-black">{cert.name}</h3>
            <p className="mt-2 text-base text-dark-grey">{cert.description}</p>
          </div>
        ))}
      </div>
      <p className="mx-auto mt-10 max-w-3xl rounded-lg border border-seafoam/40 bg-seafoam/10 px-5 py-4 text-base text-dark-grey">
        <strong className="text-black">2026 HIPAA Security Rule update:</strong>{" "}
        New requirements for ePHI access controls and audit logging take effect
        this year. Preset already meets these standards.
      </p>
    </Container>
  )
}

export default ComplianceBadgesSection
